(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-component-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-item-filter')) {
    customElements.define(
      'accordion-item-filter',
      class AccordionItemFilter extends HTMLElement {
        constructor() {
          super();
          this.heading = this.querySelector('.accordion-container__heading-area');
          this.content = this.querySelector('.accordion-container__content');
          this.type = this.dataset.type || 'normal';

          this.heading.addEventListener('click', this.singleToggleAccordion.bind(this));

          if (this.type == 'sort_by') {
            this.addEventListener('input', (e) => {
              console.log(e.target.dataset.name);
              document.querySelector('#sort_title').innerText = e.target.dataset.name;
            });
          }
        }

        singleToggleAccordion() {
          this.querySelector('.accordion-container__content').style.height = '0px';
          const isOpen = this.classList.contains('open');

          if (isOpen) {
            this.closeAccordion();
          } else {
            this.openAccordion();
          }
        }

        toggleAccordion() {
          this.closest('filter-drawer')
            .querySelectorAll('accordion-item-filter')
            .forEach((item) => {
              if (item !== this) {
                item.classList.remove('open');
                item.querySelector('.accordion-container__content').style.height = '0px';
              }
            });

          const isOpen = this.classList.contains('open');

          if (isOpen) {
            this.closeAccordion();
          } else {
            this.openAccordion();
          }
        }

        openAccordion() {
          this.classList.add('open');
          const contentHeight = this.content.scrollHeight;
          this.content.style.height = `${contentHeight + 3}px`;
        }

        closeAccordion() {
          this.classList.remove('open');
          this.content.style.height = '0px';
        }

        connectedCallback() {
          // Initial collapse
          this.content.style.height = '0px';
          this.content.style.opacity = '1';

          const filterDrawer = this.closest('filter-drawer');
          if (!filterDrawer) return;

          // Ensure _accordions exists
          if (!filterDrawer._accordions) {
            filterDrawer._accordions = [];
            this.setupFilterDrawerListeners(filterDrawer);
          }

          // Avoid duplicate pushes
          if (!filterDrawer._accordions.includes(this)) {
            filterDrawer._accordions.push(this);
          }

          // Only open first accordion if this is the *first time*
          if (filterDrawer._accordions.length === 1) {
            this.openAccordion();
          } else {
            this.closeAccordion();
          }
        }

        disconnectedCallback() {
          // Clean up reference when element is removed
          const filterDrawer = this.closest('filter-drawer');
          if (filterDrawer && filterDrawer._accordions) {
            const index = filterDrawer._accordions.indexOf(this);
            if (index > -1) {
              filterDrawer._accordions.splice(index, 1);
            }
          }
        }

        setupFilterDrawerListeners(filterDrawer) {
          // Listen for filter close event
          filterDrawer.addEventListener('filterClose', (e) => {
            // Close all accordions within this filter drawer
            const accordions = filterDrawer.querySelectorAll('accordion-item-filter');
            setTimeout(() => {
              accordions.forEach((accordion) => {
                accordion.closeAccordion();
              });

              // Open the first accordion if it exists
              if (accordions.length > 0) {
                accordions[0].openAccordion();
              }
            }, 700);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atc-nd-enquiry"] && !Shopify.designMode) return;
  try {
    window.fillInquiryFields = function () {
    const dataEl = document.getElementById('inquiry-product-data');
    if (!dataEl) return;

    const productName = dataEl.dataset.productName || '';

    const productCodeEl = document.getElementById('ProductCodeSS');
    const productCode = productCodeEl
      ? productCodeEl.textContent.trim()
      : dataEl.dataset.productCode || '';

    let variantName = '';
    if (dataEl.dataset.hasOnlyDefaultVariant !== 'true') {
      const variantsEl = document.getElementById('inquiry-variants-json');
      if (variantsEl) {
        try {
          const variants = JSON.parse(variantsEl.textContent);
          const drawerChecked = document.querySelector(
            '#variant-drawer-content input[type="radio"][name="id"]:checked'
          );
          const hiddenInput = document.querySelector('product-form input[name="id"]');
          const currentVariantId =
            (drawerChecked && (drawerChecked.dataset.variantId || drawerChecked.value)) ||
            (hiddenInput && hiddenInput.value) ||
            null;

          if (currentVariantId) {
            const found = variants.find((v) => String(v.id) === String(currentVariantId));
            if (found) variantName = found.title;
          }
        } catch (e) {}
      }
    }

    ['', '--mobile'].forEach((suffix) => {
      const pcField = document.getElementById(`product-code${suffix}`);
      if (pcField) pcField.value = productCode;
      const pnField = document.getElementById(`inquiry-product-name${suffix}`);
      if (pnField) pnField.value = productName;
      const pvField = document.getElementById(`inquiry-variant-name${suffix}`);
      if (pvField) pvField.value = variantName;
    });
  };

  // Shared helpers — available to sticky button, drawer POA button, etc.
  window.openMobileEnquiryForm = function () {
    if (typeof window.fillInquiryFields === 'function') window.fillInquiryFields();
    const mobileMenuEl = document.querySelector('mobile-menu');
    document.querySelector('custom-header')?.classList.remove('custom-header--hidden');

    // Slide the form panel in from the right. Used when the menu is ALREADY open
    // (it animates over whatever is currently showing). The reflow before .active
    // guarantees the translateX(100%)→0 transition paints on every device.
    const revealForm = () => {
      const formPanel = document.getElementById('inquiry-form-panel--mobile');
      if (!formPanel) return;
      formPanel.style.zIndex = '35';
      formPanel.classList.remove('hidden');
      void formPanel.offsetHeight; // force layout so the start state is registered
      formPanel.classList.add('active');
    };

    if (mobileMenuEl && !mobileMenuEl.isDrawerOpen) {
      // Opening fresh: place the form panel in position INSTANTLY (transition:none)
      // right after openDrawer() runs, so it rides in WITH the drawer's slide-in. The
      // user lands straight on the form — no menu/contact flash for ~200ms followed by
      // the form sliding over it. openDrawer() resets the form panel to hidden and the
      // click() runs it synchronously, so we re-reveal immediately afterwards. We then
      // restore the transition so the close animation still slides out normally.
      mobileMenuEl.querySelector('#mobile-menu__drawer-btn--open')?.click();
      const formPanel = document.getElementById('inquiry-form-panel--mobile');
      if (formPanel) {
        formPanel.style.transition = 'none';
        formPanel.style.zIndex = '35';
        formPanel.classList.remove('hidden');
        formPanel.classList.add('active');
        void formPanel.offsetHeight; // commit the no-transition active state
        formPanel.style.transition = ''; // restore for the close animation
      }
    } else if (mobileMenuEl) {
      // Menu already open (e.g. iOS — scroll lock doesn't prevent taps outside the drawer).
      // The drawer transform is already settled, so clear the contact section and reveal now.
      const contactDrawer = mobileMenuEl.querySelector('#mobile-contact-drawer');
      if (contactDrawer) contactDrawer.classList.remove('mobile-contact-drawer--active');
      revealForm();
    } else {
      revealForm();
    }
  };

  window.openDesktopEnquiryForm = function () {
    // Fill the product fields before showing the form (the desktop Enquire button opens
    // the form directly, bypassing the Contact Us → Make Inquiry button that fills them).
    if (typeof window.fillInquiryFields === 'function') window.fillInquiryFields();
    document.querySelectorAll('.contact-drawer-trigger').forEach((trigger) => trigger.click());
    document.querySelectorAll('#inquiry-form-panel').forEach((form) => form.classList.remove('hidden'));
  };

  document.querySelector('#make-enquiry-button')?.addEventListener('click', () => {
    if (window.innerWidth < 1200) {
      window.openMobileEnquiryForm();
    } else {
      window.openDesktopEnquiryForm();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-sticky-button"] && !Shopify.designMode) return;
  try {
    document.querySelector('#make-enquiry-button--sticky')?.addEventListener('click', () => {
    // Match the site-wide mobile/desktop breakpoint (mobile menu shows at <1200px).
    // Must be strict < 1200: at exactly 1200px the mobile menu is display:none, so
    // openMobileEnquiryForm() would open an invisible, scroll-locking drawer.
    if (window.innerWidth < 1200) {
      if (typeof window.openMobileEnquiryForm === 'function') {
        window.openMobileEnquiryForm();
      }
    } else {
      if (typeof window.openDesktopEnquiryForm === 'function') {
        window.openDesktopEnquiryForm();
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.getElementById('sticky-atc');
    const mainButtonContainer = document.querySelector('#atc-enquiry-buttons');

    if (!stickyAtc) {
      console.error('Sticky ATC element not found');
      return;
    }

    // Track visibility state of different sections
    let isMainButtonVisible = false;
    let isCollectionVisible = false;
    let isFooterVisible = false;

    function updateStickyVisibility() {
      // The sticky bar only exists below 1200px (display:none at >=1200), so the
      // mobile/desktop divider here must be 1200 too — otherwise on tablets
      // (968-1199px) the bar would stay visible over the footer/collection.
      const isMobile = window.innerWidth < 1200;

      // On desktop, hide only when main button is visible
      if (!isMobile) {
        if (isMainButtonVisible) {
          hideStickyBar();
        } else {
          showStickyBar();
        }
        return;
      }

      // On mobile, hide if ANY of the sections are visible
      if (isMainButtonVisible || isCollectionVisible || isFooterVisible) {
        hideStickyBar();
      } else {
        showStickyBar();
      }
    }

    function hideStickyBar() {
      stickyAtc.classList.remove('sticky-atc--visible');
      stickyAtc.classList.add('sticky-atc--hidden');
    }

    function showStickyBar() {
      stickyAtc.classList.remove('sticky-atc--hidden');
      stickyAtc.classList.add('sticky-atc--visible');
    }

    // Observer for main button container
    if (mainButtonContainer) {
      const mainButtonObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isMainButtonVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      mainButtonObserver.observe(mainButtonContainer);
    }

    // Observer for animated collection section (mobile only)
    const animatedCollection = document.querySelector('[data-section-type="animated-collection"]');
    if (animatedCollection) {
      const collectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isCollectionVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      collectionObserver.observe(animatedCollection);
    }

    // Observer for footer (mobile only)
    const footer = document.querySelector('.global-footer');
    if (footer) {
      const footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isFooterVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      footerObserver.observe(footer);
    }

    // Handle resize events
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateStickyVisibility();
      }, 150);
    });

    // Sync sticky price with main price on variant change
    const stickyPriceEl = stickyAtc.querySelector('.price-pov__container');
    let mainPriceEl = null;
    for (const el of document.querySelectorAll('.price-pov__container')) {
      if (!stickyAtc.contains(el)) {
        mainPriceEl = el;
        break;
      }
    }
    if (mainPriceEl && stickyPriceEl) {
      new MutationObserver(function () {
        stickyPriceEl.innerHTML = mainPriceEl.innerHTML;
      }).observe(mainPriceEl, { childList: true, subtree: true });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
